import { Box } from "@mui/material";
import React from "react";
import PageContainer from "../theme/comtainer/PageContainer";
import UserMain from "./components/UserMain";
import UserProvider from "./UserProvider";

const UserPage = () => {
  return (
    <UserProvider>
      <PageContainer
        title={"Tài khoản"}
        boxTitle={""}
        content={
          <Box>
            <UserMain />
          </Box>
        }
      />
    </UserProvider>
  );
};

export default UserPage;
